import { render } from "./GuardianMain.vue?vue&type=template&id=0265bccc&scoped=true&ts=true"
import script from "./GuardianMain.vue?vue&type=script&lang=ts"
export * from "./GuardianMain.vue?vue&type=script&lang=ts"

import "./GuardianMain.vue?vue&type=style&index=0&id=0265bccc&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0265bccc"]])

export default __exports__